module.exports = __webpack_public_path__ + "static/media/attach.28fe075f.svg";